export type MyScheduleSection = {
  id:
    | 'overview'
    | 'my-schedule'
    | 'my-requests'
    | 'swap-shifts'
    | 'group-schedule'
    | 'group-tallies';
  navLabel: string;
  path: string;
};

export const myScheduleSections: MyScheduleSection[] = [
  {
    id: 'overview',
    navLabel: 'Overview',
    path: '/my-schedule',
  },
  {
    id: 'my-schedule',
    navLabel: 'My Schedule',
    path: '/my-schedule/calendar',
  },
  {
    id: 'my-requests',
    navLabel: 'My Requests',
    path: '/my-schedule/requests',
  },
  {
    id: 'swap-shifts',
    navLabel: 'Swap Shifts',
    path: '/my-schedule/swap-shifts',
  },
  {
    id: 'group-schedule',
    navLabel: 'Department Schedule',
    path: '/my-schedule/group-schedule',
  },
  {
    id: 'group-tallies',
    navLabel: 'Department Tallies',
    path: '/my-schedule/group-tallies',
  },
];
